import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getFunctions = store => store[NAME].functions;
export const getTypeList = store => store[NAME].typeList;
export const getTemplateListsVars = store => store[NAME].templateListsVars;
